export class StateAcronym {
  constructor(private readonly value: string) {}

  public getValue(): string {
    return this.value;
  }
}
